import { parseApiError } from '@ooh/contracts';

export class OfferConflictError extends Error {
  constructor(
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'OfferConflictError';
  }
}

export function rethrowOfferConflict(error: unknown): never {
  const parsed = parseApiError(error);

  if (parsed.statusCode === 409) {
    throw new OfferConflictError(parsed.message, parsed.details);
  }

  throw error;
}
